<template>
    <div id="app" :class="util.isMobile() ? 'm' : 'pc'">
        <div class="app-top">
			<top v-if="!route.meta.no_common"></top>
		</div>
        <div class="app-content">
			<transition :name="moveName">
				<keep-alive>
					<router-view v-if="$route.meta.keep"></router-view>
				</keep-alive>
			</transition>
			<transition :name="moveName">
				<router-view v-if="!$route.meta.keep"></router-view>
			</transition>
		</div>
		<div class="app-bottom">
			<bottom v-if="!route.meta.no_common && show_bottom"></bottom>
		</div>
<!--        <bar v-if="util.isMobile()"></bar>-->
        <auth v-if="show_auth"></auth>
        <wait v-if="show_wait"></wait>
    </div>
</template>

<script>
import Bar from "@/components/m/Bar";
import VConsole from "vconsole";
const isMobile = () => {
	var is_mobile = false;
	var ua = navigator.userAgent.toLowerCase();
	if (/mobile|android|iphone|ipad|phone/i.test(ua)) {
		is_mobile = true;
	}
	return is_mobile;
};

export default {
	name: 'app',
	data() {
		return {
			moveName: 'fade',
			loading_show:true,
			loading_progress:0,
			loading_images:[],
		}
	},
	components:{
		Top(resolve){
			var tmp = isMobile() ? 'm':'pc';
			require([`./components/${tmp}/Top`], resolve);
		},
		Bottom(resolve){
			var tmp = isMobile() ? 'm':'pc';
			require([`./components/${tmp}/Bottom`], resolve);
		},
		Sponsor(resolve){
			var tmp = isMobile() ? 'm':'pc';
			require([`./components/${tmp}/Sponsor`], resolve);
		},
		Auth(resolve){
			var tmp = isMobile() ? 'm':'pc';
			require([`./components/${tmp}/Auth`], resolve);
		},
		Wait(resolve){
			var tmp = isMobile() ? 'm':'pc';
			require([`./components/${tmp}/Wait`], resolve);
		},
		Bar,
	},
	computed:{
		route(){
			return this.$route;
		},
		mobile(){
			return this.util.isMobile()
		},
		show_auth(){
			return this.$store.state.show_auth.show;
		},
		show_wait(){
			return this.$store.state.show_wait;
		},
		show_bottom(){
			return this.$store.state.show_bottom;
		}
	},
	watch:{
		$route(to,from){
			this.util.showBottom(false);
			this.setTitle(to);
			this.report(to,from);
			this.setBackgroundColor(to);
			if(this.util.isMobile()){
				this.share.wxShare(1);
			}
		}
	},
	methods: {
		setTitle(to){
			if(to.meta.title){
				document.title = to.meta.title || '大会信息丨2026戴尔科技峰会-进化 乘势而上-戴尔(Dell)企业采购网';
			}
		},
		setBackgroundColor(to){
			if(to.meta.background){
				document.documentElement.style.background = to.meta.background;
			}else{
				document.documentElement.style.background = '#fff';
			}
		},
		report(to,from){
			if(to.path === '/branch'){return false;}
			var gioParams = {
				module_pvar: "2021DTF大会",
				category1_pvar:to.meta.category,
				category2_pvar:"",
				title_pvar:to.meta.title,
				url_pvar:window.location.href
			}
			gio('page.set', gioParams);
		},
		doLoading(){
			let over = false;
			this.loadImage(this.loading_images, (a, b, c) => {
				this.loading_progress = Math.round((b / c) * 100);
				if (b == c && !over) {
					over = true;
					this.loading_show = false;
				}
			})
		},
		loadImage(urls, callback) {
			var max_length = 0;
			if (urls.constructor === Array) {
				max_length = urls.length;
				this.urls = urls;
			}
			this.oneLoadImg(this.urls, callback, max_length);
			this.oneLoadImg(this.urls, callback, max_length);
			this.oneLoadImg(this.urls, callback, max_length);
			this.oneLoadImg(this.urls, callback, max_length);
			this.oneLoadImg(this.urls, callback, max_length);
			this.oneLoadImg(this.urls, callback, max_length);
		},
		oneLoadImg(urls, callback, max_lenth) {
			var url = require('./assets/image/'+this.urls.pop())
			var img = new Image();
			img.src = url;
			img.onload = () => {
				callback && callback(url, max_lenth - (this.urls.length || 0), max_lenth);
				if (this.urls.length >= 1) {
					this.oneLoadImg(this.urls, callback, max_lenth);
				} else {
					this.onload = null;
				}
			}
		},
		setRem(){
			var ___resize = ()=>{
				document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
			}
			window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", ___resize(), false);
			___resize();
		},
		guestLogin(){
			if(this.util.getGuestUid()){
				return false;
			}
			this.http.request({
				api:"auth/guestLogin",
				data:{
					userAgent:navigator.userAgent,
					browser:this.tool.type.browserType(),
					version:this.tool.type.browserVersion(),
					os:this.tool.type.os(),
					equipment:this.util.isMobile()?'移动端':'电脑端',
					resolution:document.documentElement.clientWidth+"x"+document.documentElement.clientHeight,
					referenceUrl:"",
					referenceTitle:""
				},
				success:(res)=>{
					this.util.setGuestUid(res.guest_uid);
				}
			})
		},
		getUserInfo(){
			if(!this.util.getAccessToken()){
				return false;
			}
			this.http.request({
				api:'user/getUserInfo',
				async:1,
				success:(res)=>{
					this.$store.commit('setUserInfo',res.user);
          this.util.setDellCookie();
				}
			})
		},
		setChannel(){
			var channel = this.tool.other.getUrlParams('channel');
			if(channel){
				this.tool.storage.setLocal('channel',channel)
			}else{
				this.tool.storage.removeLocal('channel')
			}
		},
		createConsole(){
			if(this.tool.other.getUrlParams('debug')){
				new VConsole();
			}
		}
	},
	mounted() {
		if(this.util.isMobile()){
			this.setRem();
		}
		this.setTitle(this.$route);
		this.report(this.$route);
		this.setBackgroundColor(this.$route);
		if(this.util.isMobile()){
			this.share.wxShare(1);
		}
		this.createConsole();
	},
	created() {
		this.setChannel();
		this.guestLogin();
		this.getUserInfo();
	}
}
</script>

<style lang="scss" type="text/scss" >
    @import 'assets/css/reset.scss';
    /*.fade-enter {opacity:0;}*/
    /*.fade-leave{opacity:1;}*/
    /*.fade-enter-active{transition:opacity .5s;}*/
    /*.fade-leave-active{opacity:0;transition:opacity .5s;}*/
    .zoom-enter-active,.zoom-leave-active{transition: all .3s ease-out;}
    .zoom-enter{transform: scale3d(0,0,0);}
    .zoom-leave,.zoom-leave-active{transform: scale3d(0,0,0);}
	#app{display: flex;flex-direction: column;justify-content: space-between;min-height: 100vh;
		.app-content{flex: 1;position: relative;}
	}
    #app.pc{min-width: 1200px;min-height: calc(100vh + 10px)}
    #app.m{font-size: .28rem;/*padding-bottom: 1rem;*/}
    .start-loading{position: fixed;top:0;left:0;width: 100%;height:100%;z-index: 500;
        .con{position: absolute;top:50%;left:50%;transform: translate(-50%,-50%);
            .line{width:2.26rem;height:.06rem;position: relative;margin-top:.1rem;
                .webview-progress{position: absolute;top:0;left:0;width:0;height:100%;background: linear-gradient(to right,#93aff4,#305af8);}
            }
            .tit{text-align: center;font-size: .26rem;color:#618efc;margin-top:.2rem;}
        }
    }
    .empty{height:200px;line-height: 200px;text-align: center;font-size: 16px;color:#999;}
    .data-loading{height:500px;line-height: 500px; background: none;}
    .m-loading{height:6rem;line-height:6rem; background: none;}
</style>
